<template>
  <div class="device-list" v-loading="loading">
    <div class="filter-wrap">
      <div class="filter-item">
        <span class="label">设备ID</span>
        <el-input v-model="deviceId" placeholder="请输入设备ID" @input="queryDevice"></el-input>
      </div>
      <!--      <div class="filter-item">-->
      <!--        <span class="label">设备型号</span>-->
      <!--        <el-select v-model="deviceModel" clearable placeholder="请选择">-->
      <!--          <el-option-->
      <!--            v-for="(item, index) in deviceModels"-->
      <!--            :key="index"-->
      <!--            :label="item.label"-->
      <!--            :value="item.sheetId"-->
      <!--          ></el-option>-->
      <!--        </el-select>-->
      <!--      </div>-->
      <div class="query">
        <BaseButton @click="queryDevice">查询</BaseButton>
      </div>
    </div>
    <section class="main-wrap">
      <base-table
        ref="BaseTable"
        tableHeight="100%"
        :data="filterDevices"
        :pageInfo="pageInfo"
        @page-change="refresh"
      >
        <el-table-column
          v-for="item in deviceColumns"
          :key="item.value"
          :label="item.label"
          :prop="item.value"
          :column-key="item.value"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="viewCollectData(scope.row)">查看采集数据</el-button>
          </template>
        </el-table-column>
      </base-table>
    </section>
  </div>
</template>

<script>
import { deviceColumns } from "@/views/IOT/DeviceLog/static"
import BaseTable from "@/components/UIComponents/BaseTable"
import BaseButton from "@/components/UIComponents/Button"
import { getDeviceList } from "@/api/iot/device"
import mixin from "@/views/IOT/DeviceLog/mixin"

export default {
  name: "DeviceList",
  components: { BaseButton, BaseTable },
  data() {
    return {
      deviceColumns,
      loading: false,
      deviceId: "",
      deviceName: "",
      deviceModel: "",
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      devices: [],
      filterDevices: []
      // 暂不需要
      // deviceModels: [
      //   {
      //     label: "型号1",
      //     value: "1"
      //   },
      //   {
      //     label: "型号2",
      //     value: "2"
      //   }
      // ]
    }
  },
  mixins: [mixin],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      getDeviceList().then(res => {
        this.devices = res.map(device => {
          device.metricNumber = device.metric.length
          return device
        })
        this.filterDevices = this.devices
        this.resetPageInfo(this.filterDevices)
        this.loading = false
      })
    },
    viewCollectData(data) {
      this.$emit("viewCollectData", data.sn)
    },
    queryDevice() {
      this.filterDevices = this.devices.filter(device => device.sn.includes(this.deviceId))
    }
  }
}
</script>

<style lang="scss" scoped>
.device-list {
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .filter-wrap {
    display: flex;
    margin: 10px 20px;
    font-size: 14px;
    .filter-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .label {
        width: 60px;
      }
    }
  }
  .main-wrap {
    flex: 1 1;
    overflow: hidden;
    padding: 0 20px;
    .base-table {
      height: 100%;
    }
  }
}
</style>
